module.exports = __webpack_public_path__ + "img/arrow.9f451d57.png";